import React, { useState, useEffect, useCallback } from "react";
import {
  Typography,
  Divider,
  Button,
  TextField,
  Grid,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import useStyles from "./style";
import CustomSwitch from "SharedComponents/CustomSwitch";
import { useFormik } from "formik";
import * as yup from "yup";
import settingsApi from "Services/Settings";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

const Settings = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [appState, setAppState] = useState(true);
  const [smsState, setSmsState] = useState(true);
  const [values, setValues] = useState(null);

  // Save or Edit profile details
  const handleSettings = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    const data = {
      pv_price: formValues?.pv,
      google_key: formValues?.googleKey,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Settings Updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik?.resetForm();
        setValues(null);
        getMasterValues();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update settings",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("settings value update api", err);
    };
    settingsApi.updateMasterValues({ ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      pv: "",
      googleKey: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      pv: yup
        .number()
        .required("Pv value is required")
        .min(1, "Pv value must be 1 or greater than 1")
        .nullable(),
      googleKey: yup.string().required("Google key is required").nullable(),
    }),
    onSubmit: handleSettings,
  });

  // Update App or sms state details
  const handleUpdateStates = (type) => {
    dispatch(showLoader("Loading please wait..."));
    const data1 = {
      app_enable: appState ? "false" : "true",
    };
    const data2 = {
      sms_enable: smsState ? "0" : "1",
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated sms successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setValues(null);
        getMasterValues();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update sms",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("settings state update api", err);
    };
    type === 1
      ? settingsApi.updateAppState({ ...data1 }).then(onSuccess, onFailure)
      : settingsApi.updateSmsState({ ...data2 }).then(onSuccess, onFailure);
  };

  // Get MAster values
  const getMasterValues = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get master values list Api", err);
    };
    settingsApi.getMasterValues().then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getMasterValues();
  }, [getMasterValues]);

  // Set fetched values for master
  useEffect(() => {
    if (!_.isEmpty(values)) {
      formik.setFieldValue("pv", values?.pv_price);
      formik.setFieldValue("googleKey", values?.android_api_key);
      values?.app_enable && values?.app_enable === true
        ? setAppState(true)
        : setAppState(false);
      values?.sms_enable && values?.sms_enable === "1"
        ? setSmsState(true)
        : setSmsState(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <>
      <h2>Site Settings</h2>
      <Grid container>
        <Grid item xs={12} className={classes.container}>
          <Grid item xs={12} sm={6} className={classes.fieldWrapper}>
            <TextField
              name="siteName"
              id="siteLogo"
              value={formik?.values?.pv}
              onChange={formik?.handleChange}
              type={"text"}
              fullWidth
              variant="outlined"
              size="small"
              label="Site Name*"
              error={formik?.errors?.pv && formik?.touched?.pv}
              helperText={
                formik?.errors?.pv && formik?.touched?.pv && formik?.errors?.pv
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} className={classes.fieldWrapper}>
            <TextField
              name="googleKey"
              id="googleKey"
              value={formik?.values?.googleKey}
              onChange={formik?.handleChange}
              type={"text"}
              fullWidth
              variant="outlined"
              size="small"
              label="Google key*"
              error={formik?.errors?.googleKey && formik?.touched?.googleKey}
              helperText={
                formik?.errors?.googleKey &&
                formik?.touched?.googleKey &&
                formik?.errors?.googleKey
              }
            />
          </Grid>
          <Grid item xs={12} className={classes.btn}>
            <Button variant="contained" onClick={formik.handleSubmit}>
              Update
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Settings;
